export default "__VITE_ASSET__BV$uajYX__"